import { useContext } from "react";
import Context from "../../Context";

import styles from "./Consorcio.module.css"
import WPContent from "../DefaultPack/WPContent";

const Consorcio = () => {
    const { imagens, textos } = useContext(Context);

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.texto}>
                    <WPContent conteudo={textos.consorcio} />
                    {/* <img src={imagens.consorcio.large} alt="Consórcio" /> */}
                </div>
            </div>
        </>
    )
}

export default Consorcio;